import { Platform, StatusBar, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    heightPercentageToDP,
    isTablet,
    isTabletOrWeb,
    isWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

import { CHANNEL_HEIGHT } from 'screens/Settings/components/ChannelLineupItem/styles';

import { ImageSize } from 'components/NagraImage/types';

const MOBILE_TOP_PADDING = StatusBar.currentHeight || 20;

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%',
        minHeight: heightPercentageToDP(56),
        marginBottom: heightPercentageToDP(8),
        paddingLeft: widthPercentageToDP(16),
    },
    logo: { width: ImageSize.SETTINGS_LIST_CHANNEL_LOGO.width },
    dialog: {
        paddingTop: Platform.select({
            web: 0,
            default: isTablet
                ? 0
                : heightPercentageToDP(MOBILE_TOP_PADDING + 44),
        }),
        paddingHorizontal: 16,
        marginBottom: androidScreenMarginBottom,
    },
    button: { minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328) },
    buttonText: {
        color: COLOR.BLACK,
    },
    saveButton: { fontSize: 20 },
    actionButton: { minWidth: widthPercentageToDP(90) },
    switchContainer: {
        width: widthPercentageToDP(330, 640, 460),
        minWidth: isWeb ? 688 : 0,
        left: widthPercentageToDP(16, 160, 0),
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        height: CHANNEL_HEIGHT,
        zIndex: 1,
        borderRadius: 6,
        padding: 20,
    },
    stickyContainerForWeb: {
        // @ts-ignore
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: COLOR.BLACK,
    },
    headerText: {
        fontSize: 20,
        color: COLOR.WHITE,
    },
    line: {
        width: widthPercentageToDP(330, 640, 460),
        minWidth: isWeb ? 688 : 0,
        left: widthPercentageToDP(16, 160, 0),
        height: 2,
        backgroundColor: COLOR.LIGHT_GREY,
        marginVertical: 8,
    },
    channelListWrapper: {
        flex: 1,
    },
});

export default styles;
